export default "__VITE_ASSET__1da4aa93__"